// @ts-nocheck
import create from 'zustand';
import { immer } from 'zustand/middleware/immer';
import _ from 'lodash';
import { axios } from "./axios";
import { showError, showSuccess } from "../actions/globalActions";

const baseUrl = `${process.env.API_URL}/api/v1`;

const createAuthHeader = (token) => {
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
};

const usePaymentStore = create(immer((set) => ({
  paymentPlans: [],
  payments: [],

  // Methods to manipulate the state
  setPayments: (payments) => {
    set((state) => {
      state.payments = payments;
    });
  },

  // Asynchronous actions
  getPaymentsByRegistrationId: async (id, token) => {
    try {
      const { data } = await axios.get(`${baseUrl}/payments/registration/${id}/all`, createAuthHeader(token));
      set((state) => {
        state.payments = data.result;
      });
    } catch (error) {
      console.error("Error in getPaymentsByRegistrationId:", error);
    }
  },

  // INT-0018: installment plans for the registration (badges on team rows).
  getPaymentPlansByRegistrationId: async (id, token) => {
    try {
      const { data } = await axios.get(`${baseUrl}/payments/registration/${id}/plans`, createAuthHeader(token));
      set((state) => {
        state.paymentPlans = data.result || [];
      });
    } catch (error) {
      console.error("Error in getPaymentPlansByRegistrationId:", error);
    }
  },

  getPaymentsByLeagueName: async (leagueName, token) => {
    try {
      const { data } = await axios.get(`${baseUrl}/payments/organization/${leagueName}?include=registration.tournament,registration.contest,registrationTeam,user(email,name)`, createAuthHeader(token));
      set((state) => {
        state.payments = data.result;
      });
    } catch (error) {
      console.error("Error in getPaymentsByLeagueName:", error);
    }
  
  },

  refundPaymentByRegistrationTeamId: (getToken) => {
    return async (registrationTeamId, refundAmount, leagueId, paymentIntentId) => {
      try {
        const token = await getToken();
        const { error, result, status } = (await axios.post(`${baseUrl}/payments/refundAmount/${registrationTeamId}`,
          { refundAmount, leagueId, paymentIntentId }, createAuthHeader(token))).data;
        if (error) {
          showError("Error", error);
        } else {
          showSuccess("Success", "Successfully Refunded");
          set((state) => {
            state.payments = state.payments.filter((p) => p.registrationTeam !== registrationTeamId);
          });
        }
      } catch (error) {
        console.error("Error in refundPaymentByRegistrationTeamId:", error);
      }
    }
  },

  refundPaymentByPaymentIntentId: (getToken) => {
    return async (paymentIntentId, refundAmount, leagueId) => {
      try {
        const token = await getToken();
        const { error, result, status } = (await axios.post(`${baseUrl}/payments/refund/${paymentIntentId}`, { refundAmount, leagueId }, createAuthHeader(token))).data;
        if (error) {
          showError("Error", error);
        } else {
          showSuccess("Success", "Successfully Refunded");
          set((state) => {
            state.payments = state.payments.filter((p) => p.stripe_payment_intent !== paymentIntentId);
          });
        }
      } catch (error) {
        console.error("Error in refundPaymentByPaymentIntentId:", error);
      }
    }
  },

  replayStripeEvents: async (sessions, token) => {
    const { data } = await axios.post(
      `${baseUrl}/admins/stripe/replay-events`,
      { sessions },
      createAuthHeader(token)
    );
    return data.result;
  },

})));

export default usePaymentStore;